import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { validateEnv } from "./presentation/utils/env-validator";
import MockDate from 'mockdate';
import { pdfjs } from "react-pdf";
import { Buffer } from 'buffer';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { error } from "console";

window.Buffer = Buffer;
// Valida variáveis de ambiente no arranque antes de renderizar
validateEnv();


// MockDate.set('2027-01-20T12:00:00'); // Para testar com data mocked

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url
).toString();

if (process.env.NODE_ENV === 'development') {
  import('eruda').then(eruda => eruda.default.init());
}
//
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/sw.js`;
    navigator.serviceWorker.register(swUrl).then((registration) => { 

      console.log('[PSA] Service Worker registered with scope:', registration.scope);
    })
    .catch((error) => {
      console.error('[PWA] Service Worker registration failed:', error);
      
    });
  });
}